<template>
  <div>
    <v-layout class="elements" wrap row>
      <drag
        v-for="(field, index) in otherFields"
        :key="index"
        :transfer-data="getCustomDropData(field)"
        class="item"
      >
        <span>{{ field.name }}</span>
      </drag>
      <drag
        v-for="(field, index) in avatarField"
        :key="index"
        :transfer-data="dropData.customAvatar"
        class="item"
      >
        <span>{{ field.name }}</span>
      </drag>
      <drag :transfer-data="dropData.fullName" class="item">
        <span>Full name</span>
      </drag>
      <drag
        v-if="countryField"
        :transfer-data="dropData.countryName"
        class="item"
      >
        <span>Country name</span>
      </drag>
      <drag
        v-if="countryField"
        :transfer-data="dropData.flag"
        class="item"
      >
        <span>Country flag</span>
      </drag>
      <drag
        v-if="countryField"
        :transfer-data="dropData.countryCode"
        class="item"
      >
        <span>Country code</span>
      </drag>
      <drag
        v-if="extraModules.categoriesAndZones"
        :transfer-data="dropData.category"
        class="item"
      >
        <span>Category </span>
      </drag>
      <drag :transfer-data="dropData.avatar" class="item">
        <span>Attendee image</span>
      </drag>
      <drag :transfer-data="dropData.rectangle" class="item">
        <span>Rectangle</span>
      </drag>
      <drag :transfer-data="dropData.roundedRectangle" class="item">
        <span>Rounded rectangle</span>
      </drag>
      <drag :transfer-data="dropData.qrCode" class="item">
        <span>QR code</span>
      </drag>
      <drag :transfer-data="dropData.customText" class="item">
        <span>Text</span>
      </drag>
      <drag :transfer-data="dropData.id" class="item">
        <span>Id</span>
      </drag>
      <drag :transfer-data="dropData.customImage" class="item">
        <span>Image</span>
      </drag>
      <drag :transfer-data="dropData.oval" class="item">
        <span>Oval</span>
      </drag>
      <drag :transfer-data="dropData.barcode" class="item">
        <span>Barcode</span>
      </drag>
      <drag :transfer-data="dropData.printCount" class="item">
        <span>Print count</span>
      </drag>
    </v-layout>
    <div v-if="extraModules.categoriesAndZones" class="item" style="cursor: default">
      <span class="small-title">
        Zones
      </span>
      <div class="zones-item">
        <drag
          v-for="zone in zones"
          :key="zone"
          :transfer-data="getZoneData(zone)"
          class="item zone-item"
        >
          <span>{{ zone }}</span>
        </drag>
      </div>
    </div>
  </div>
</template>

<script>

import { defaultStyles, dropData } from './builder.utils'

export default {
  name: 'builder-elements',
  props: {
    zones: Array,
    fields: {
      type: Array,
      default: () => ([]),
    },
    extraModules: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defaultStyles,
      dropData,
    }
  },
  computed: {
    countryField(){
      return this.fields.find(f => f.type==='country')
    },
    avatarField() {
      return this.fields.filter(f => f.type==='avatar-field')
    },
    otherFields(){
      return this.fields.filter(f => f.type!=='country' && f.type!=='avatar-field')
    },
  },
  methods: {
    getZoneData(zone) {
      return {
        ...this.dropData.zone,
        placeholder: zone,
      }
    },
    getCustomDropData({ name, ...rest }) {
      return {
        placeholder: name,
        meta: rest,
        ...this.dropData.custom,
      }
    },
  },
}
</script>

<style scoped>
.item {
  border: 1px #979797 dashed;
  border-radius: 8px;
  padding: 6px 10px;
  margin: 0 15px 15px 0;
  cursor: grab;
}
.zones-item {
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.zone-item {
  width: 35px;
  height: 35px;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 8px 8px 0;
  border: solid 1px rgba(151, 151, 151, 0.54);
}
.elements > div {
  width: 40%;
  min-width: 100px;
}
</style>

